/**
 * Created by Angelika on 28.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';

const initialState = {
    isFetching: false,
    error: null,
    items: [],
    activeGenre: null
};

export function genres(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_GENRES_REQUEST:
            return {
                ...state,
                isFetching: true,
                items: [],
                error: null
            };

        case actionTypes.GET_GENRES_SUCCESS:
            return {
                ...state,
                isFetching: false,
                error: null,
                items: action.genres
            };

        case actionTypes.GET_GENRES_FAILED:
            return {
                ...state,
                isFetching: false,
                error: action.error,
                items: []
            };

        case actionTypes.SET_GENRE_FILTER:
            return {
                ...state,
                activeGenre: action.genre
            };

        case actionTypes.RESET_GENRE_FILTER:
            return {
                ...state,
                activeGenre: null
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/genres.js